<template>
	<div class="loader">
<!--     <svg class="circular" height="50" width="50" ng-show="showpreloader">
      <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="1" stroke-miterlimit="10"></circle>
    </svg> -->
	</div>
</template>

<script>
	export default {
		name: 'loader',
		props: ['label']
	}
</script>

<style lang="scss">
  .loading-page {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .circular {
      width: 50px;
      height: 50px;
      animation: rotate 2s linear infinite;
    }

    .path {
      stroke-dasharray: 1, 500;
      stroke-dashoffset: 0;
      stroke-linecap: round;
      stroke: $basic_black;
      animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
    }

    @keyframes rotate {
      0% {
        transform: rotate(0deg) scale(1.5);
      }

      100% {
        transform: rotate(360deg) scale(1.5);
      }
    }

    @keyframes dash {
      0% {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
      }

      50% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -35;
      }

      100% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -124;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/vue/components/common/content/Loader.vue?b6fda1da